import React from "react"
import { Button } from "@puregym/ui"
import { RouteKey } from "src/hooks/useRoutes"
import { useNavigateTo } from "src/hooks/useNavigateTo"

export const ButtonLink: React.FCWithChildren<{
  route: RouteKey
  variant?: string
  id?: string
  disabled?: boolean
  fullWidth?: boolean
}> = ({ route, children, ...buttonProps }) => {
  const navigateTo = useNavigateTo()

  const onClick = () => {
    navigateTo(route)
  }

  return (
    <Button {...buttonProps} onClick={onClick}>
      {children}
    </Button>
  )
}
